module.exports = ".cnt-text span {\n  width: 260px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden; }\n"